export default "__VITE_ASSET__Cw3euvVw__"